/**
 * TECHNICHEM CUSTOM: Product card size pill variant selector
 *
 * When a size pill is clicked:
 *   1. Highlights the active pill
 *   2. Updates the ATC button's variant ID
 *   3. Updates the displayed price
 *   4. Swaps the product image to the variant's assigned image
 *   5. Disables ATC if variant is unavailable
 *
 * Variant data comes from a JSON script block (data-tc-variant-data)
 * rendered by snippets/product-grid-item.liquid. Each variant object
 * includes featured_image with src/width/height when assigned in
 * Shopify admin (Products > variant > image).
 *
 * Image swap uses Shopify CDN ?width= parameter for resizing.
 * Only variants with an assigned featured_image will trigger a swap.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.tc-size-pill');
    if (!pill) return;

    var card = pill.closest('.productgrid--item') || pill.closest('[data-product-item]');
    if (!card) return;

    var pillsContainer = pill.closest('[data-tc-size-pills]');
    if (!pillsContainer) return;

    var variantId = pill.getAttribute('data-tc-variant-id');
    var variantPrice = pill.getAttribute('data-tc-variant-price');
    var variantAvailable = pill.getAttribute('data-tc-variant-available') === 'true';

    var allPills = pillsContainer.querySelectorAll('.tc-size-pill');
    for (var i = 0; i < allPills.length; i++) {
      allPills[i].classList.remove('tc-size-pill--active');
    }
    pill.classList.add('tc-size-pill--active');

    var atcButton = card.querySelector('[data-quick-buy]');
    if (atcButton && variantId) {
      atcButton.setAttribute('data-variant-id', variantId);
      var atcText = atcButton.querySelector('.atc-button--text');
      if (variantAvailable) {
        atcButton.disabled = false;
        atcButton.classList.remove('disabled');
        if (atcText) atcText.textContent = 'Add to cart';
      } else {
        atcButton.disabled = true;
        atcButton.classList.add('disabled');
        if (atcText) atcText.textContent = 'Sold out';
      }
    }

    if (variantPrice) {
      var priceContainer = card.querySelector('.productitem__price .price__current');
      if (priceContainer) {
        // Range display ("$min - $max" or "from $min") collapses to the
        // selected variant's exact price
        if (priceContainer.querySelector('.price__current--min') || priceContainer.querySelector('.price--label')) {
          priceContainer.innerHTML = '<span class="money" data-price></span>';
        }
        var moneyEl = priceContainer.querySelector('.money');
        if (moneyEl) {
          moneyEl.textContent = variantPrice;
        }
      }
    }

    if (variantId) {
      var jsonScript = card.querySelector('[data-tc-variant-data]');
      if (jsonScript) {
        try {
          var data = JSON.parse(jsonScript.textContent);
          var variant = null;
          var vid = parseInt(variantId, 10);
          for (var j = 0; j < data.variants.length; j++) {
            if (data.variants[j].id === vid) {
              variant = data.variants[j];
              break;
            }
          }

          if (variant && variant.featured_image && variant.featured_image.src) {
            var imgSrc = variant.featured_image.src;

            // Ensure protocol for consistent URL handling
            if (imgSrc.indexOf('//') === 0) {
              imgSrc = 'https:' + imgSrc;
            }

            // Shopify CDN: use ?width= param for resizing (works with /files/ paths)
            var sized = imgSrc.indexOf('?') > -1
              ? imgSrc + '&width=600'
              : imgSrc + '?width=600';

            var imgEl = card.querySelector('.productitem--image-primary');
            if (imgEl) {
              imgEl.setAttribute('src', sized);
              imgEl.setAttribute('srcset', sized + ' 1x');

              // Tell Empire's rimg system this image is already loaded
              imgEl.setAttribute('data-rimg', 'loaded');

              // Hide the canvas placeholder that rimg uses as a loading overlay
              var canvas = imgEl.parentElement
                ? imgEl.parentElement.querySelector('[data-rimg-canvas]')
                : null;
              if (canvas) {
                canvas.style.display = 'none';
              }
            }
          }
        } catch (err) {
          // Variant JSON parse failed - skip image swap silently
        }
      }
    }
  });
})();
